module.exports = __webpack_public_path__ + "static/4-39924004d764eff98b8a0ba6a701c4b8.png";